import { environment } from 'src/environments/environment';
import { LocationService } from './../../services/location.service';
import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import * as mapboxgl from 'mapbox-gl';
import { Coordinates } from 'src/app/models/coordinates.model';
import { MapboxButtonControl } from './controls/mapbox-button-control';

@Component({
    selector: 'mapbox-map',
    templateUrl: './mapbox-map.component.html',
    styleUrls: ['./mapbox-map.component.scss'],
    standalone: false
})
export class MapboxMapComponent implements OnInit, AfterViewInit {

	// @ContentChildren(LeafletTileLayerComponent) public tileLayers!: QueryList<LeafletTileLayerComponent>;

	// @ContentChildren(LeafletLayerComponent) public layers!: QueryList<LeafletLayerComponent>;
	// @ContentChildren(LeafletGeoJsonLayerComponent) public geoJSONlayers!: QueryList<LeafletGeoJsonLayerComponent>;

	// @ContentChildren(LeafletPathComponent) public paths!: QueryList<LeafletPathComponent>;
	// @ContentChildren(LeafletMarkerComponent) public markers!: QueryList<LeafletMarkerComponent>;
	// @ContentChildren(LeafletCircleMarkerComponent) public circleMarkers!: QueryList<LeafletCircleMarkerComponent>;
	// @ContentChildren(LeafletCircleComponent) public circles!: QueryList<LeafletCircleComponent>;
	
	// @ContentChildren(LeafletCurveComponent) public curves!: QueryList<LeafletCurveComponent>;
	// @ContentChildren(LeafletArcComponent) public arcs!: QueryList<LeafletArcComponent>;

	@Input() public style?: string | mapboxgl.Style = "mapbox://styles/peritoconsulting/cl487went002414nv8cfmrqdh";
	@Input() public zoom?: number = 4;

	private static readonly _CONTAINER_ID = "map";

	private _map: mapboxgl.Map;
	
	public async initializeMap(): Promise<void> {
		let currentPosition: Coordinates = await this._locationService.getCurrentPosition();

		

	

		this._map = new mapboxgl.Map(
			{
				accessToken: environment.mapbox.accessToken,
				container: MapboxMapComponent._CONTAINER_ID,
				style: this.style,
				center: [currentPosition.longitude, currentPosition.latitude],
				zoom: this.zoom,
			}
		);

		const scale = new mapboxgl.ScaleControl(
			{
				maxWidth: 80,
				unit: 'metric' // 'imperial' | 'metric' | 'nautical'
			}
		);

		const ctrlPoint = new MapboxButtonControl(
			{
				className: "mapbox-gl-draw_point",
				title: "Place a Marker",
				iconClassName: "fa-solid fa-location-dot",
				eventHandler: (evt) => {}
			}
		);
		
		const ctrlLine = new MapboxButtonControl(
			{
				className: "mapbox-gl-draw_line",
				title: "Draw Line",
				iconClassName: "fa-solid fa-ruler",
				eventHandler: (evt) => {}
			}
		);
		
		const ctrlPolygon = new MapboxButtonControl(
			{
				className: "mapbox-gl-draw_polygon",
				title: "Draw Polygon",
				iconClassName: "fa-solid fa-draw-polygon",
				eventHandler: (evt) => {}
			}
		);

		/* Add Controls to the Map */
		this._map.addControl(scale);
		this._map.addControl(new mapboxgl.NavigationControl(), "top-left");
		this._map.addControl(new mapboxgl.FullscreenControl());
		this._map.addControl(ctrlPoint, "bottom-left");
		this._map.addControl(ctrlLine, "bottom-right");
		this._map.addControl(ctrlPolygon, "top-right");

		

	

		
	}

  constructor(
		private _locationService: LocationService,
	) { }

  ngOnInit(): void {
		
  }

	ngAfterViewInit(): void {
		this.initializeMap();
		
		

		setTimeout(() => {
			this._map.resize();
		}, 100);
	}
}
